import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGetServicesQuery } from "../redux/services/api";
import { createExcerpt } from "../utils/excerpt";
import { useTranslation } from "../hooks/useTranslation";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Services = () => {
  const navigate = useNavigate();
  const { t, isArabic } = useTranslation();
  const swiperRef = useRef(null);

  // Use RTK Query to fetch services
  const { data: servicesData, isLoading: loading } = useGetServicesQuery();
  const services =
    servicesData?.services?.filter((service) => service && service.is_active) ||
    [];

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  // Ensure navigation stays enabled

  const handleMoreClick = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  const handleViewAllServices = () => {
    navigate("/services");
  };

  if (loading) {
    return (
      <section className="services">
        <div className="container">
          <h2 className="section-title">{t("services.title")}</h2>
          <div className="offers-container">
            <div className="loading-placeholder">
              <div className="loading-spinner"></div>
              <p>Loading services...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (services.length === 0) {
    return (
      <section className="services">
        <div className="container">
          <h2 className="section-title">{t("services.title")}</h2>
          <div className="offers-container">
            <div className="no-services">
              <p>No services available at the moment.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="services">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up" data-aos-delay="100">
          {t("services.title")}
        </h2>
        <div
          className="offers-container"
          style={{ width: "100%" }}
        >
          <Swiper
            key={`services-${isArabic ? "rtl" : "ltr"}`}
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={true}
            pagination={{
              enabled: services.length > 1,
              clickable: true,
              dynamicBullets: false,
              type: "bullets",
            }}
            dir={isArabic ? "rtl" : "ltr"}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            className="services-carousel"
            style={{ width: "100%", paddingBottom: "50px" }}
          >
            {services.map((service, index) => (
              <SwiperSlide key={service.id}>
                <div
                className="service-card clickable-service-card"
                data-aos="fade-up"
                data-aos-delay={`${200 + index * 100}`}
                onClick={() => handleMoreClick(service.id)}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
              >
                <div className="service-image">
                  {service.image_url ? (
                    <img
                      src={service.image_url}
                      alt={service.title}
                      className="service-img"
                      onError={(e) => {
                        e.target.style.display = "none";
                        if (e.target.nextSibling) {
                          e.target.nextSibling.style.display = "flex";
                        }
                      }}
                    />
                  ) : (
                    <span style={{ color: "#ccc" }}>{service.title}</span>
                  )}
                </div>
                <h3 className="offer-title-dark">
                  {isArabic && service.title_ar
                    ? service.title_ar
                    : service.title}
                </h3>
                <p className="service-description">
                  {createExcerpt(
                    isArabic && service.content_ar
                      ? service.content_ar
                      : service.content,
                    20
                  )}
                </p>
                <button
                  className="btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMoreClick(service.id);
                  }}
                >
                  {t("services.readMore")}
                </button>
              </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="view-all-services">
          <button className="btn btn-secondary" onClick={handleViewAllServices}>
            {t("services.viewAll")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
